<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_vii"><em>For my mother, who first suggested that I write a book, and my father, who later urged me to write another one.</em></a><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0048356a